<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        block
        class="white--text"
        v-on="on"
      >
        Create Claim Setting
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Entitlement Setting"
      text="Create Claim Entitlement Setting"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="claimType"
                v-validate="'required'"
                :items="claimTypes"
                label="Claim Type"
                :error-messages="errors.collect('claimType')"
                data-vv-name="claimType"   
                data-vv-as="claim type"   
                item-text="name"
                item-value="id"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="creditUnit"
                v-validate="'required'"
                :items="creditUnits"
                label="Credit Unit"
                :error-messages="errors.collect('creditUnit')"
                data-vv-name="creditUnit"   
                data-vv-as="credit unit"   
                item-text="name"
                item-value="name"
              />
            </v-col>

            <v-col
              v-if="creditUnit && creditUnit === 'day'"
              cols="6"
            >
              <span> Includes end date? </span>
              <v-radio-group
                v-model="includesEndDate"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="creditUnit && creditUnit === 'day' && includesEndDate"
              cols="6"
            >
              <span> Allow claim half entitlement? </span>
              <v-radio-group
                v-model="allowHalfClaim"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="creditUnit && creditUnit === 'day' && !allowHalfClaim"
              cols="6"
            >
              <span> Allow combine entitlement? </span>
              <v-radio-group
                v-model="allowCombineEntitlement"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>
      
          <v-row class="mt-n3">
            <v-col>
              <span class="font-weight-bold pr-2">Claim Entitlement Setting Details:</span>
              <v-tooltip
                v-if="details.length < jobCategories.length"
                bottom
              >
                <template v-slot:activator="{ on: tooltip }">
                  <v-icon
                    color="primary"
                    v-on="{ ...dialog, ...tooltip }"
                    @click="addRow"
                  >
                    mdi-plus
                  </v-icon>
                </template>
                <span>Add new row</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row
            v-for="(detail,counter) in details"
            :key="counter"
          >
            <v-col
              cols="5"
              class="py-0"
            >
              <v-autocomplete
                v-model="detail.job_category_id"
                v-validate="'required'"
                :items="jobCategories"
                label="Job Category"
                :name="'job_category_id' + counter"
                :error-messages="errors.collect('job_category_id' + counter)"
                data-vv-delay="500"
                data-vv-name="jobCategory"   
                data-vv-as="job category"   
                item-text="name"
                item-value="id"
              />
            </v-col>
            <v-col
              cols="5"
              class="py-0"
            >
              <v-text-field
                v-model="detail.max_amount"
                v-validate="'required|validAmount'"
                v-money="money"
                :name="'max_amount' + counter"
                :error-messages="errors.collect('max_amount' + counter)"
                data-vv-delay="500"
                data-vv-as="amount"
                label="Maximum Claim Amount"
                prefix="RM"
                :suffix="'/' + creditUnit"
              />
            </v-col>

            <v-col class="text-center">
              <v-icon
                color="error"
                @click="deleteRow(counter)"
              >
                mdi-window-close
              </v-icon>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="px-10 white--text"
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        name: null,
        details: [],
        claimTypes: [],
        jobCategories: [],
        claimType: null,
        creditUnit: null,
        creditUnits: ['day', 'month', 'year'],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        includesEndDate: 1,
        allowHalfClaim: 0,
        allowCombineEntitlement: 0,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.resetForm()
        this.loadClaimType()
        
        this.jobCategories.forEach(category => {
          this.details.push({ job_category_id: category.id, max_amount: null })
        })

        this.$validator.extend('validAmount', {
          getMessage (field, args) {
            return 'Amount should be more than 0'
          },
          validate (value, args) {
            return value.toString().replaceAll(',', '') > 0
          },
        })
      },
    },
    mounted () {
      this.loadJobCategories()
    },

    methods: {
      submitForm () { 
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.claimEntitlementSettings().create(this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: 'Claim Entitlement Setting Added Successfully' })

                this.dialog = false
              })
              .catch(() => {
                this.$snack({ color: 'error', message: 'Unable to create claim entitlement setting' })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.name,
          claim_type_id: this.claimType,
          credit_unit: this.creditUnit,
          details: this.details,
          includes_end_date: this.creditUnit === 'day' ? this.includesEndDate : 1,
          allow_claim_half_entitlement: this.creditUnit === 'day' && this.includesEndDate ? this.allowHalfClaim : 0,
          is_fixed_amount: this.creditUnit === 'day' && this.includesEndDate ? this.allowHalfClaim : 0,
          allow_combine_entitlement: this.creditUnit === 'day' && !this.allowHalfClaim ? this.allowCombineEntitlement : 0,
        }
      },
      addRow () {
        this.details.push({ job_category_id: null, max_amount: null })
      },
      deleteRow (counter) {
        this.details.splice(counter, 1)
      },
      resetForm () {
        this.$validator.reset()
        this.name = null
        this.claimType = null
        this.creditUnit = null
        this.details = []
        this.includesEndDate = 1
        this.allowHalfClaim = 0
        this.allowCombineEntitlement = 0
      },
      loadJobCategories () {
        this.$api.jobCategories().list()
          .then(res => {
            this.jobCategories = res.data
          })
      },
      loadClaimType () {
        this.$api.claimTypes().list()
          .then(res => {
            this.claimTypes = res.data.filter(claimType => {
              return claimType.has_limit === 1
            })
          })
      }, 
    },
  }
</script>

<style>
.example.theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before{
  border:none
}
</style>
